export interface Ratio {
  part: number;
  total: number;
}
